export type stageType = 'development' | 'production';

export const STAGE = (process.env.REACT_APP_STAGE as stageType) || 'development';

export const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID;
